import React, { useEffect, useRef, useState } from "react";
import "./Itixplatform.css";

/* ============================================================
   CONTENT  (client ka content – yahin se edit karo)
   ============================================================ */
const HEAD = {
  badge: "ONE PLATFORM",
  title: "One Platform. Multiple Workflows.",
  subtitle: "iTixFiles connects the essential parts of everyday work:",
};

const FLOW = [
  { label: "People", icon: "users" },
  { label: "Digital Files", icon: "folder" },
  { label: "Documents", icon: "file" },
  { label: "Applications", icon: "form" },
  { label: "Workflows", icon: "flow" },
  { label: "Tickets", icon: "ticket" },
  { label: "Completion", icon: "check" },
];

const TEXT =
  "Whether you are managing personal documents, processing public-service applications, digitizing archived records or coordinating organizational work, iTixFiles helps bring information and action together.";

const SCENARIOS = [
  "Personal documents",
  "Public-service applications",
  "Archived records",
  "Organizational work",
];

/* ============================================================
   ICONS
   ============================================================ */
const ICONS = {
  users: (<><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></>),
  folder: (<path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z" />),
  file: (<><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" /><path d="M14 2v4a2 2 0 0 0 2 2h4M8 13h8M8 17h8M8 9h2" /></>),
  form: (<><rect x="4" y="3" width="16" height="18" rx="2" /><path d="M8 8h8M8 12h8M8 16h4" /></>),
  flow: (<><rect x="3" y="3" width="6" height="6" rx="1" /><rect x="15" y="15" width="6" height="6" rx="1" /><path d="M6 9v3a3 3 0 0 0 3 3h6M12 15l3 0" /></>),
  ticket: (<><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" /><path d="M13 5v2M13 11v2M13 17v2" /></>),
  check: (<><circle cx="12" cy="12" r="10" /><path d="m8 12 3 3 5-6" /></>),
};

const Icon = ({ name, size = 28 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {ICONS[name]}
  </svg>
);

/* scroll-in hook */
const useInView = (threshold = 0.2) => {
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    if (!("IntersectionObserver" in window)) {
      setSeen(true);
      return undefined;
    }
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setSeen(true);
          io.disconnect();
        }
      },
      { threshold }
    );
    io.observe(node);
    return () => io.disconnect();
  }, [threshold]);
  return [ref, seen];
};

/* ============================================================
   SECTION
   ============================================================ */
const ITixPlatform = () => {
  const [ref, seen] = useInView();

  return (
    <section ref={ref} className={`ip ${seen ? "ip--in" : ""}`} id="platform">
      <div className="ip__container">
        {/* ---------- heading ---------- */}
        <header className="ip__head">
          <span className="ip__pill ip__r">{HEAD.badge}</span>
          <h2 className="ip__title ip__r" style={{ "--i": 1 }}>
            {HEAD.title}
          </h2>
          <p className="ip__subtitle ip__r" style={{ "--i": 2 }}>
            {HEAD.subtitle}
          </p>
          <span className="ip__underline" />
        </header>

        {/* ---------- connected flow ---------- */}
        <div className="ip__board ip__r" style={{ "--i": 3 }}>
          <ol className="ip__flow">
            {FLOW.map((f, i) => (
              <li className="ip__node" key={f.label} style={{ "--n": i }}>
                <span className="ip__orb">
                  <span className="ip__orb-ring" />
                  <Icon name={f.icon} />
                  <em>{String(i + 1).padStart(2, "0")}</em>
                </span>
                <span className="ip__label">{f.label}</span>
              </li>
            ))}
          </ol>

          <div className="ip__board-foot">
            <p>{TEXT}</p>
            <ul className="ip__chips">
              {SCENARIOS.map((s) => (
                <li key={s}>{s}</li>
              ))}
            </ul>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ITixPlatform;